import { render, staticRenderFns } from "./lamsRegLegalConsultSummaryDetail.vue?vue&type=template&id=4c991283&scoped=true&"
import script from "./lamsRegLegalConsultSummaryDetail.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalConsultSummaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./lamsRegLegalConsultSummaryDetail.vue?vue&type=style&index=0&id=4c991283&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c991283",
  null
  
)

export default component.exports